export default __webpack_public_path__ + "images/3492d16ff2d1cfce714c8be23ef0d593.png";